<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="tw-space-y-2">
        <div class="row">
          <div class="col-md-12">
            <label class="required col-form-label">{{
              $t('exchangeRate.date')
            }}</label>
            <DatePicker
              v-model="model.dates"
              class="tw-w-full"
              show-time
              placeholder="Select Time"
              format="dd-MM-yyyy HH:mm:ss"
              valueFormat="dd-MM-yyyy HH:mm:ss"
            ></DatePicker>
            <div class="validate text-danger tw-text-xs" v-if="errors.has('dates')">
              {{ errors.first('dates') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="required col-form-label">{{
              $t('exchangeRate.exchangeCurrency')
            }}</label>
            <div class="tw-flex">
              <div class="tw-w-5/12 from_currency">
                <Select
                  v-model.number="model.currency_id_from"
                  disabled
                  class="tw-w-full"
                >
                  <Option
                                                v-for="item in currencies"
                                                :value="item.value"
                                                :key="item.value"
                                                :label="item.label"
                                            >
                                                {{ item.label }}
                  </Option>
                </Select>
              </div>
              <div class="tw-w-2/12 tw-text-center">
                <input
                  class="form-control"
                  placeholder="To"
                  readonly
                  style="border-radius: 0;text-align: center; height:32px !important"
                />
              </div>
              <div class="tw-w-5/12 to_currency">
                <Select
                  v-model.number="model.currency_id_to"
                  class="tw-w-full"
                >
                <Option
                                                v-for="item in currencies"
                                                :value="item.value"
                                                :key="item.value"
                                                :label="item.label"
                                            >
                                                {{ item.label }}
                  </Option>
              </Select>
              </div>
            </div>
            <div>
              <i>
                <span class="tw-text-xs tw-text-gray-500">
                  {{ note }}
                </span>
              </i>
            </div>
            <div class="invalid-feedback" v-if="errors.has('currency_id_from')">
              {{ errors.first('currency_id_from') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label class="required col-form-label">{{
              $t('exchangeRate.fxRate')
            }}</label>
            <input
              v-model.number="model.fx_rate"
              type="number"
              class="form-control"
              :class="{ 'is-invalid': errors.has('fx_rate') }"
              @change="onChangeFxRate"
            />
            <div class="validate text-danger tw-text-xs" v-if="errors.has('fx_rate')">
              {{ errors.first('fx_rate') }}
            </div>
          </div>
          <div class="col-md-6">
            <label class="required col-form-label">{{
              $t('exchangeRate.fxRateRatio')
            }}</label>
            <input
              v-model.number="model.fx_rate_ratio"
              type="number"
              readonly
              class="form-control"
              :class="{ 'is-invalid': errors.has('fx_rate_ratio') }"
            />
            <div class="validate text-danger tw-text-xs" v-if="errors.has('fx_rate_ratio')">
              {{ errors.first('fx_rate_ratio') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="required col-form-label">{{
              $t('exchangeRate.remarks')
            }}</label>
            <textarea
              rows="3"
              class="form-control"
              :placeholder="$t('exchangeRate.remarks')"
              v-model.trim="model.remarks"
            ></textarea>
            <div class="validate text-danger tw-text-xs" v-if="errors.has('remarks')">
              {{ errors.first('remarks') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 tw-mt-3 tw-text-right">
            <ts-button class="tw-mr-2" @click.prevent="() => $emit('cancel')">
              {{ $t('cancel') }}
            </ts-button>
            <ts-button
              color="primary"
              @click.prevent="onSave"
              :waiting="waiting"
              >{{ $t('save') }}</ts-button
            >
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import moment from 'moment'
import { Errors } from 'form-backend-validation'

export default {
  name: 'exchangeRateForm',
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      loading: false,
      waiting_new: false,
      currencies: [],
      default_currency: null,
      model: {
        dates: moment().format('DD-MM-YYYY HH:mm:ss'),
        currency_id_from: null,
        currency_id_to: null,
        fx_rate: null,
        fx_rate_ratio: null,
        remarks: null
      }
    }
  },
  created() {
    this.fetchCurrency()
  },
  computed: {
    note() {
      if (this.currencies) {
        let from_currency = this.currencies.find(
          c => c.value == this.model.currency_id_from
        )

        let to_currency = this.currencies.find(
          c => c.value == this.model.currency_id_to
        )

        if (from_currency && to_currency) {
          return (
            'Note* : 1 ' +
            from_currency.currency_code +
            ' ' +
            to_currency.compare_to_default_currency +
            ' ' +
            '1 ' +
            to_currency.currency_code
          )
        }
        return 'Note*: '
      }
      return 'Note*: '
    }
  },
  methods: {
    onChangeFxRate() {
      let to_currency = this.currencies.find(
        c => c.value == this.model.currency_id_to
      )

      if (to_currency.compare_to_default_currency == '>') {
        this.model.fx_rate_ratio = 1 / this.model.fx_rate
        this.model.remarks = 'Fx Rate Ratio = 1 / Fx Rate'
      } else {
        this.model.fx_rate_ratio = 1 * this.model.fx_rate
        this.model.remarks = 'Fx Rate Ratio = 1 * Fx Rate'
      }
    },
    fetchCurrency() {
      this.loading = true
      this.$store
        .dispatch('exchangeRate/currencyRate/getCurrency')
        .then(response => {
          this.default_currency = response.data.find(
            el => el.is_default == true
          )
          this.model.currency_id_from = this.default_currency.currency_id
          this.currencies = response.data.map(el => ({
            value: el.currency_id,
            label: el.currency_code,
            currency_code: el.currency_code,
            compare_to_default_currency: el.compare_to_default_currency
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSave() {
      this.waiting = true
      this.errors = new Errors()
      this.$store
        .dispatch('exchangeRate/currencyRate/store', this.model)
        .then(response => {
					this.notice({ type: 'success', text: response.message })
					this.$emit('cancel')
					this.$emit('fetchData')
				})
				.catch(error => {
					this.errors = new Errors(error.errors)
					this.notice({ type: 'error', text: error.message })
				})
        .finally(() => {
          this.waiting = false
        })
    },
    notice(not) {
            this.$Notice[not.type]({
                title: "OCCUPATION",
                desc: not.text
            });
        }
  },
  watch: {
    'model.currency_id_to': {
      handler() {
        this.onChangeFxRate()
      },
      deep: true
    }
  }
}
</script>
<style>
.from_currency .ant-select-selection {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.to_currency .ant-select-selection {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
</style>
